/* ============================================================
   ToTheLove — Barre d'achat collante (sticky ATC)
   ------------------------------------------------------------
   Custom element <ttl-sticky-atc> (réinit auto au shopify:section:load).
   - Prix miroir du `#price-*` Dawn (variantes + promo).
   - Bouton délègue au vrai `.product-form__submit`.
   - Apparition via IntersectionObserver quand le vrai ATC est hors écran.

   Sync variante : Dawn remplace l'innerHTML de #price-* (le nœud .price
   est détruit) → on observe le conteneur + on écoute variant-change /
   change sur les radios packs, sinon le sticky reste sur l'ancien prix.
   Cache-bust: 2026-08-14-sticky-sync-v1
   ============================================================ */
(function () {
  if (customElements.get('ttl-sticky-atc')) return;

  class TtlStickyAtc extends HTMLElement {
    connectedCallback() {
      this.priceTarget = this.querySelector('[data-ttl-sticky-price]');
      this.addBtn = this.querySelector('[data-ttl-sticky-add]');
      this.labelEl = this.querySelector('[data-ttl-sticky-label]');
      this.labelAdd = this.dataset.labelAdd || (this.labelEl && this.labelEl.textContent.trim());
      this._syncT = 0;

      this.scope =
        document.querySelector('product-info') ||
        document.querySelector('.product__info-container') ||
        document;

      this.refreshRefs();
      if (!this.realSubmit) return;

      this.syncPrice();
      this.syncState();
      this.bindEvents();
      this.observeReveal();
    }

    refreshRefs() {
      this.realSubmit = this.scope.querySelector('.product-form__submit') || this.realSubmit;
      this.priceWrap = this.scope.querySelector('[id^="price-"]');
      this.mainPrice =
        (this.priceWrap && this.priceWrap.querySelector('.price')) ||
        this.scope.querySelector('.price--large') ||
        this.scope.querySelector('.price');
    }

    bindEvents() {
      this.addBtn.addEventListener('click', () => {
        if (this.addBtn.hasAttribute('disabled')) return;
        this.refreshRefs();
        if (this.realSubmit) this.realSubmit.click();
      });

      /* Conteneur #price-* survivit au swap Dawn ; .price non. */
      var priceRoot = this.priceWrap || this.scope;
      this._priceMo = new MutationObserver(() => this.syncPrice());
      this._priceMo.observe(priceRoot, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['class'],
      });

      this._btnMo = new MutationObserver(() => this.syncState());
      this._btnMo.observe(this.realSubmit, {
        attributes: true,
        attributeFilter: ['disabled', 'aria-disabled', 'class'],
        childList: true,
        subtree: true,
      });

      this._onScopeChange = this._onScopeChange.bind(this);
      this.scope.addEventListener('change', this._onScopeChange);

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this._unsubVariant = subscribe(PUB_SUB_EVENTS.variantChange, () => {
          this.queueSync();
        });
        this._unsubOption = subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, () => {
          this.queueSync();
        });
      }

      this._onSectionLoad = this._onSectionLoad.bind(this);
      document.addEventListener('shopify:section:load', this._onSectionLoad);
    }

    _onSectionLoad() {
      this.refreshRefs();
      this.syncPrice();
      this.syncState();
    }

    _onScopeChange(e) {
      var t = e.target;
      if (!t) return;
      if (
        t.matches &&
        (t.matches('input[type="radio"]') ||
          t.matches('select') ||
          t.matches('[name="id"]') ||
          t.matches('[name="selling_plan"]') ||
          t.matches('.rc-radio__input'))
      ) {
        this.queueSync();
      }
    }

    queueSync() {
      var self = this;
      clearTimeout(this._syncT);
      this._syncT = setTimeout(function () {
        self.refreshRefs();
        self.syncPrice();
        self.syncState();
      }, 30);
      /* Dawn fetch async : 2e passe après le swap prix. */
      setTimeout(function () {
        self.refreshRefs();
        self.syncPrice();
        self.syncState();
      }, 350);
    }

    syncPrice() {
      this.refreshRefs();
      if (!this.mainPrice || !this.priceTarget) return;
      this.priceTarget.className = 'ttl-sticky-atc__price ' + this.mainPrice.className;
      this.priceTarget.innerHTML = this.mainPrice.innerHTML;
    }

    syncState() {
      this.refreshRefs();
      if (!this.realSubmit) return;
      var disabled =
        this.realSubmit.hasAttribute('disabled') ||
        this.realSubmit.getAttribute('aria-disabled') === 'true';
      this.addBtn.toggleAttribute('disabled', disabled);

      var realSpan = this.realSubmit.querySelector('span:not(.visually-hidden)');
      var realText = realSpan ? realSpan.textContent.trim() : '';
      if (this.labelEl) {
        this.labelEl.textContent = disabled && realText ? realText : this.labelAdd;
      }
    }

    observeReveal() {
      this._io = new IntersectionObserver(
        (entries) => {
          var entry = entries[0];
          this.toggle(!entry.isIntersecting);
        },
        { threshold: 0, rootMargin: '0px' }
      );
      this._io.observe(this.realSubmit);
      requestAnimationFrame(() => {
        var rect = this.realSubmit.getBoundingClientRect();
        var inView = rect.top < window.innerHeight && rect.bottom > 0;
        this.toggle(!inView);
      });
    }

    toggle(show) {
      this.classList.toggle('is-visible', show);
      this.setAttribute('aria-hidden', show ? 'false' : 'true');
    }

    disconnectedCallback() {
      clearTimeout(this._syncT);
      if (this._io) this._io.disconnect();
      if (this._priceMo) this._priceMo.disconnect();
      if (this._btnMo) this._btnMo.disconnect();
      if (this._unsubVariant) this._unsubVariant();
      if (this._unsubOption) this._unsubOption();
      if (this.scope && this._onScopeChange) {
        this.scope.removeEventListener('change', this._onScopeChange);
      }
      document.removeEventListener('shopify:section:load', this._onSectionLoad);
    }
  }

  customElements.define('ttl-sticky-atc', TtlStickyAtc);
})();
/* sticky-sync-v1-cdn */
